<template>
  <span>{{ stateText }}</span>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    items: Array,
    value: String,
  },
  watch: {
    value(n) {
      this.innerValue = n;
    },
    innerValue(value) {
      this.$emit("input", value);
    },
  },
  computed: {
    ...mapState({
      USStates: (state) => state.account.states,
    }),

    stateText() {
      let f = this.options.find((option) => {
        return option.code === this.value
      });
      if (f) {
        return f.text;
      }
      return this.value;
    },

    resetProps() {
      return { ...this.$attrs };
    },
    options() {
        return this.USStates.map(state => {
            return {
                ...state,
                text: state.name,
                value: state.code
            }
        })
    }
  },

  methods: {
    emitBlur() {
      this.$emit("blur");
    },
  },
  data() {
    return {
      innerValue: "",
    };
  },
};
</script>